import { render, staticRenderFns } from "./wtMassProduce.component.vue?vue&type=template&id=1e2c1c5b&scoped=true&"
import script from "./wtMassProduce.component.vue?vue&type=script&lang=js&"
export * from "./wtMassProduce.component.vue?vue&type=script&lang=js&"
import style0 from "./wtMassProduce.component.vue?vue&type=style&index=0&id=1e2c1c5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2c1c5b",
  null
  
)

export default component.exports